import { useState } from 'react';

interface ButtonProp {
  label?: string;
  id?: string;
  icon?: React.SVGProps<SVGSVGElement>;
  color?: string;
  borderColor?: string;
  colorHover?: string;
  textColor?: string;
  padding?: number;
  disable?: boolean
  onClick: () => void;
};


export function Button( { label, id, icon, disable, color, colorHover, borderColor, textColor, padding, onClick }: ButtonProp ) {

  const [ isHover, setIsHover ] = useState( false );

  const handleMouseEnter = () => {
    setIsHover( true );
  };
  const handleMouseLeave = () => {
    setIsHover( false );
  };

  const looksLikeTailwind = ( v?: string ) => {
    if ( !v ) {return false;}
    return v.includes( 'bg-' ) || v.includes( 'text-' ) || v.includes( 'hover:' ) || v.includes( 'border-' ) || v.includes( 'p-' ) || v.includes( 'px-' ) || v.includes( 'py-' );
  };

  const useClassMode = looksLikeTailwind( color ) || looksLikeTailwind( colorHover ) || looksLikeTailwind( borderColor ) || looksLikeTailwind( textColor );

  const style = useClassMode ? undefined : {
    backgroundColor: disable ? '#d1d5db' : (  color ? ( colorHover && isHover ? colorHover : color ) : '#0bb173' ),
    borderColor: disable ? '#d1d5db' : (  color ? ( colorHover && isHover ? colorHover : borderColor ? borderColor : '#FFFFFF' ) : '#0bb173' ),
    borderWidth: '2px',
    color: textColor ? textColor : '#FFFFFF',
    padding: padding && !label ? padding + 'px' : '6px',
  } as React.CSSProperties | undefined;

  const classVars = [
    color ?? '',
    colorHover ?? '',
    borderColor ?? '',
    textColor ?? ''
  ].filter( Boolean ).join( ' ' );

  const baseClass = 'flex w-full h-full self-center items-center text-sm font-semibold border select-none';
  const interactiveClass = disable ? ' cursor-not-allowed' : ' cursor-pointer transition ease-in-out delay-75 active:scale-95';
  const shapeClass = label ? ' px-2 py-1 m-2 rounded-lg' : ' rounded-full';

  const combinedClassName = useClassMode ? `${baseClass} ${interactiveClass} ${shapeClass} ${classVars}` : `${baseClass}${interactiveClass}${shapeClass}`;

  return (
    <div className='flex h-full w-full'>
      <div
        id={ id }
        className={ combinedClassName }
        style={ style }
        onClick={ () => {
          if ( !disable ) {
            onClick();
          }
        } }
        onMouseEnter={ handleMouseEnter }
        onMouseLeave={ handleMouseLeave }
      >
        {
          icon ?
            <div> { icon as JSX.Element } </div>
            :
            null
        }
        {
          label ?
            <p className="flex w-full pl-2 pr-1 justify-center">{ label }</p>
            :
            null
        }
      </div>
    </div>
  );
};